import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";
import LoaderBox from "../HomePage/LoaderBox";

const AdminSettingsStats = ({ onBack }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const calculateLiveStats = async () => {
      setLoading(true);
      try {
        const { data: matches, error } = await supabase.from("matches").select(`
            *,
            team_a:team_a_id(name),
            team_b:team_b_id(name)
          `);

        if (error) throw error;

        if (matches) {
          let stvarnoOdigrano = 0;
          let ukupnoGolova = 0;
          let najvecaRazlika = -1;
          let najvećePobjedeLista = [];

          const timoviStats = {};
          const unikatniTimovi = new Set();
          matches.forEach((match) => {
            const timA = match.team_a?.name || "Nepoznat Tim A";
            const timB = match.team_b?.name || "Nepoznat Tim B";
            if (match.team_a_id) unikatniTimovi.add(match.team_a_id);
            if (match.team_b_id) unikatniTimovi.add(match.team_b_id);
            if (!timoviStats[timA]) timoviStats[timA] = { zabio: 0, primio: 0 };
            if (!timoviStats[timB]) timoviStats[timB] = { zabio: 0, primio: 0 };

            const jePredanaTekma =
              ((match.scorea === 3 && match.scoreb === 0) ||
                (match.scorea === 0 && match.scoreb === 3)) &&
              (!match.events || match.events.length === 0);

            if (!jePredanaTekma && match.is_completed) {
              stvarnoOdigrano += 1;
              ukupnoGolova += match.scorea + match.scoreb;

              timoviStats[timA].zabio += match.scorea;
              timoviStats[timA].primio += match.scoreb;

              timoviStats[timB].zabio += match.scoreb;
              timoviStats[timB].primio += match.scorea;

              const razlika = Math.abs(match.scorea - match.scoreb);
              if (razlika >= najvecaRazlika) {
                const tekstMeca = `${timA} vs ${timB} (${match.scorea}:${match.scoreb})`;

                if (razlika > najvecaRazlika) {
                  najvecaRazlika = razlika;
                  najvećePobjedeLista = [tekstMeca];
                } else {
                  najvećePobjedeLista.push(tekstMeca);
                }
              }
            }
          });
          let najvisePrimljenih = { tim: "-", golovi: -1 };
          let najboljiNapad = { tim: "-", golovi: 0 };
          let najboljaObrana = { tim: "-", golovi: Infinity };

          Object.keys(timoviStats).forEach((tim) => {
            if (timoviStats[tim].zabio === 0 && timoviStats[tim].primio === 0)
              return;
            if (timoviStats[tim].primio > najvisePrimljenih.golovi) {
              najvisePrimljenih = { tim: tim, golovi: timoviStats[tim].primio };
            }
            if (timoviStats[tim].zabio > najboljiNapad.golovi) {
              najboljiNapad = { tim: tim, golovi: timoviStats[tim].zabio };
            }
            if (timoviStats[tim].primio < najboljaObrana.golovi) {
              najboljaObrana = { tim: tim, golovi: timoviStats[tim].primio };
            }
          });

          const prosjek =
            stvarnoOdigrano > 0
              ? (ukupnoGolova / stvarnoOdigrano).toFixed(2)
              : 0;

          setStats({
            brojEkipa: unikatniTimovi.size,
            stvarnoOdigrano,
            ukupnoGolova,
            prosjek,
            najvećePobjedeLista: najvećePobjedeLista.slice(0, 5),
            najboljiNapad,
            najboljaObrana,
            najvisePrimljenih,
          });
        }
      } catch (err) {
        console.error("Greška:", err.message);
      } finally {
        setLoading(false);
      }
    };

    calculateLiveStats();
  }, []);

  if (loading) return <LoaderBox text="Generiram izvještaj..." />;
  if (!stats) return <p className="error-text">Greška pri učitavanju.</p>;

  return (
    <div className="admin-stats-dashboard">
      {" "}
      <button className="back-btn" onClick={onBack}>
        <i className="fi fi-rs-arrow-left"></i> Natrag
      </button>
      <div className="dashboard-header">
        <h3>STATISTIKA TURNIRA</h3>
        <p className="subtitle"></p>
      </div>
      <div className="stats-list">
        <div className="stat-card">
          <div className="card-info">
            <span className="card-label">
              Broj ekipa<i class="fi fi-rs-employees"></i>
            </span>
            <span className="card-desc">Ukupan broj ekipa</span>
          </div>
          <div className="card-badge">{stats.brojEkipa}</div>
        </div>
        <div className="stat-card">
          <div className="card-info">
            <span className="card-label">
              Odigrane utakmice<i class="fi fi-rs-court-sport"></i>
            </span>
            <span className="card-desc">
              Ukupan broj odigranih utakmica na turniru
            </span>
          </div>
          <div className="card-badge">{stats.stvarnoOdigrano}</div>
        </div>

        <div className="stat-card">
          <div className="card-info">
            <span className="card-label">
              Postignuto golova <i class="fi fi-rs-football"></i>
            </span>
            <span className="card-desc">Zbroj svih zabijenih golova</span>
          </div>
          <div className="card-badge">{stats.ukupnoGolova}</div>
        </div>

        <div className="stat-card">
          <div className="card-info">
            <span className="card-label">Prosjek po utakmici</span>
            <span className="card-desc">
              Prosjek zabijenih golova po utakmici
            </span>
          </div>
          <div className="card-badge accent">{stats.prosjek}</div>
        </div>

        <div className="section-divider">EKIPNI REKORDI</div>

        {/* NAJBOLJI NAPAD */}
        <div className="stat-card leader-card napad">
          <div className="card-info">
            <span className="card-label">Najviše zabijenih golova</span>
            <span className="card-team-name">{stats.najboljiNapad.tim}</span>
          </div>
          <div className="card-badge-large">
            {stats.najboljiNapad.golovi} <span>G</span>
          </div>
        </div>

        {/* NAJBOLJA OBRANA */}
        <div className="stat-card leader-card obrana">
          <div className="card-info">
            <span className="card-label">Najmanje primljenih golova</span>
            <span className="card-team-name">{stats.najboljaObrana.tim}</span>
          </div>
          <div className="card-badge-large">
            {stats.najboljaObrana.golovi} <span>P</span>
          </div>
        </div>
        {/* NAJVIŠE PRIMLJENIH */}
        <div className="stat-card leader-card najgora-obrana">
          <div className="card-info">
            <span className="card-label">Najviše primljenih golova</span>
            <span className="card-team-name">
              {stats.najvisePrimljenih.tim}
            </span>
          </div>
          <div className="card-badge-large">
            {stats.najvisePrimljenih.golovi} <span>P</span>
          </div>
        </div>
        <div className="section-divider">NAJVEĆE POBJEDE</div>

        {/* POPIS NAJVEĆIH POBJEDA */}
        <div className="records-vertical">
          {stats.najvećePobjedeLista.map((meca, index) => (
            <div key={index} className="record-row-item">
              <div className="icon-holder">
                <i className="fi fi-rs-trophy"></i>
              </div>
              <span className="record-text">{meca}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminSettingsStats;
